// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-canvas-projects-page {
  width: min(1500px, calc(100% - 48px));
  margin: 0 auto;
  padding: 52px 0 80px;
  color: #1b211b;
}

.admin-canvas-projects-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;
}

.admin-canvas-projects-header > div > span {
  color: #698442;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.admin-canvas-projects-header h1 {
  margin: 7px 0 6px;
  font-size: clamp(30px, 4vw, 48px);
  letter-spacing: -0.04em;
}

.admin-canvas-projects-header p {
  margin: 0;
  color: #6d746d;
  font-size: 14px;
}

.admin-canvas-projects-header > a,
.admin-canvas-projects-actions a,
.canvas-admin-route-state a {
  color: #2e4d19;
  font-weight: 700;
  text-decoration: none;
}

.admin-canvas-projects-filters {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) 180px 180px auto;
  align-items: end;
  gap: 14px;
  margin-bottom: 18px;
  padding: 18px;
  border: 1px solid #e0e5dc;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 16px 44px rgba(31, 45, 23, 0.05);
}

.admin-canvas-projects-filters label,
.admin-canvas-projects-dialog label {
  display: grid;
  gap: 7px;
}

.admin-canvas-projects-filters label > span,
.admin-canvas-projects-dialog label > span {
  color: #70776e;
  font-size: 11px;
  font-weight: 700;
}

.admin-canvas-projects-filters input,
.admin-canvas-projects-filters select,
.admin-canvas-projects-filters button,
.admin-canvas-projects-dialog textarea,
.admin-canvas-projects-dialog button {
  min-height: 42px;
  border: 1px solid #d9ded6;
  border-radius: 10px;
  background: #fff;
  color: #242a24;
  font: inherit;
}

.admin-canvas-projects-filters input,
.admin-canvas-projects-filters select,
.admin-canvas-projects-dialog textarea {
  padding: 10px 12px;
  outline: none;
}

.admin-canvas-projects-filters input:focus,
.admin-canvas-projects-filters select:focus,
.admin-canvas-projects-dialog textarea:focus,
.admin-canvas-projects-priority input:focus {
  border-color: #96b861;
  box-shadow: 0 0 0 3px rgba(150, 184, 97, 0.17);
}

.admin-canvas-projects-filters > button {
  padding: 0 22px;
  border-color: #1d251b;
  background: #1d251b;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}

.admin-canvas-projects-panel {
  overflow: hidden;
  border: 1px solid #e0e5dc;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 16px 44px rgba(31, 45, 23, 0.05);
}

.admin-canvas-projects-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 20px;
  border-bottom: 1px solid #edf0eb;
}

.admin-canvas-projects-summary span {
  color: #858b84;
  font-size: 12px;
}

.admin-canvas-projects-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 180px;
  padding: 24px;
  color: #727970;
  text-align: center;
}

.admin-canvas-projects-message.is-error { color: #a43737; }

.admin-canvas-projects-message button,
.admin-canvas-projects-pagination button,
.admin-canvas-projects-priority button,
.admin-canvas-projects-actions button {
  border: 1px solid #d9ded6;
  border-radius: 8px;
  background: #fff;
  color: #424a41;
  cursor: pointer;
}

.admin-canvas-projects-table-wrap { overflow-x: auto; }

.admin-canvas-projects-table {
  width: 100%;
  min-width: 1120px;
  border-collapse: collapse;
}

.admin-canvas-projects-table th,
.admin-canvas-projects-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #edf0eb;
  text-align: left;
  vertical-align: middle;
}

.admin-canvas-projects-table th {
  background: #f7f9f5;
  color: #767d75;
  font-size: 11px;
  letter-spacing: 0.06em;
  white-space: nowrap;
}

.admin-canvas-projects-table td { font-size: 13px; }

.admin-canvas-projects-table td > strong,
.admin-canvas-projects-table td > small {
  display: block;
}

.admin-canvas-projects-table small {
  max-width: 220px;
  margin-top: 4px;
  overflow: hidden;
  color: #858c84;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-canvas-projects-project {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 270px;
}

.admin-canvas-projects-project > div:last-child {
  min-width: 0;
}

.admin-canvas-projects-project strong {
  display: block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-canvas-projects-thumbnail {
  display: grid;
  flex: 0 0 68px;
  width: 68px;
  height: 48px;
  place-items: center;
  overflow: hidden;
  border-radius: 9px;
  background: #e9ede6;
  color: #939b91;
  font-size: 10px;
}

.admin-canvas-projects-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.admin-canvas-projects-status {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 999px;
  background: #ecefec;
  color: #646c63;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.admin-canvas-projects-status.is-public {
  background: #e7f5d7;
  color: #3d6a22;
}

.admin-canvas-projects-status.is-disabled {
  background: #fde6e3;
  color: #a33b35;
}

.admin-canvas-projects-priority {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 220px;
}

.admin-canvas-projects-priority input {
  width: 86px;
  min-height: 34px;
  padding: 6px 8px;
  border: 1px solid #d9ded6;
  border-radius: 8px;
  outline: none;
}

.admin-canvas-projects-priority button,
.admin-canvas-projects-actions button {
  min-height: 34px;
  padding: 6px 9px;
  font-size: 11px;
  white-space: nowrap;
}

.admin-canvas-projects-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 150px;
}

.admin-canvas-projects-actions .is-danger,
.admin-canvas-projects-dialog .is-danger {
  border-color: #e4a6a1;
  background: #fff3f1;
  color: #a3332d;
}

.admin-canvas-projects-priority button:disabled,
.admin-canvas-projects-actions button:disabled,
.admin-canvas-projects-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.admin-canvas-projects-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 18px;
}

.admin-canvas-projects-pagination button { padding: 7px 14px; }

.admin-canvas-projects-pagination span {
  color: #6c746b;
  font-size: 12px;
}

.admin-canvas-projects-dialog-backdrop {
  position: fixed;
  z-index: 5000;
  inset: 0;
  display: grid;
  padding: 20px;
  place-items: center;
  background: rgba(18, 23, 17, 0.48);
}

.admin-canvas-projects-dialog {
  width: min(480px, 100%);
  padding: 26px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(14, 20, 12, 0.25);
}

.admin-canvas-projects-dialog h2 { margin: 0 0 10px; }

.admin-canvas-projects-dialog p {
  margin: 0 0 20px;
  color: #656d64;
  line-height: 1.6;
}

.admin-canvas-projects-dialog textarea {
  width: 100%;
  resize: vertical;
}

.admin-canvas-projects-dialog > div {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}

.admin-canvas-projects-dialog button {
  padding: 0 18px;
  cursor: pointer;
}

.canvas-admin-route-state {
  display: grid;
  min-height: calc(100vh - 72px);
  padding: 48px 24px;
  place-content: center;
  justify-items: center;
  color: #586057;
  text-align: center;
}

.canvas-admin-route-state h1 {
  margin: 0 0 8px;
  color: #222822;
}

@media (max-width: 900px) {
  .admin-canvas-projects-page {
    width: min(100% - 28px, 1500px);
    padding-top: 34px;
  }

  .admin-canvas-projects-header { align-items: flex-start; }

  .admin-canvas-projects-filters {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 620px) {
  .admin-canvas-projects-header {
    display: grid;
  }

  .admin-canvas-projects-filters { grid-template-columns: 1fr; }

  .admin-canvas-projects-summary {
    align-items: flex-start;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/adminCanvasProjects/AdminCanvasProjectsPage.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;EAIE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C,cAAc,EAAE;;AAE1D;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,oCAAoC,gBAAgB,EAAE;;AAEtD;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kCAAkC,eAAe,EAAE;;AAEnD;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA,2CAA2C,iBAAiB,EAAE;;AAE9D;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,mCAAmC,gBAAgB,EAAE;;AAErD;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA,gCAAgC,uBAAuB,EAAE;;EAEzD;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA,iCAAiC,0BAA0B,EAAE;;EAE7D;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".admin-canvas-projects-page {\n  width: min(1500px, calc(100% - 48px));\n  margin: 0 auto;\n  padding: 52px 0 80px;\n  color: #1b211b;\n}\n\n.admin-canvas-projects-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 28px;\n}\n\n.admin-canvas-projects-header > div > span {\n  color: #698442;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n}\n\n.admin-canvas-projects-header h1 {\n  margin: 7px 0 6px;\n  font-size: clamp(30px, 4vw, 48px);\n  letter-spacing: -0.04em;\n}\n\n.admin-canvas-projects-header p {\n  margin: 0;\n  color: #6d746d;\n  font-size: 14px;\n}\n\n.admin-canvas-projects-header > a,\n.admin-canvas-projects-actions a,\n.canvas-admin-route-state a {\n  color: #2e4d19;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.admin-canvas-projects-filters {\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) 180px 180px auto;\n  align-items: end;\n  gap: 14px;\n  margin-bottom: 18px;\n  padding: 18px;\n  border: 1px solid #e0e5dc;\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 16px 44px rgba(31, 45, 23, 0.05);\n}\n\n.admin-canvas-projects-filters label,\n.admin-canvas-projects-dialog label {\n  display: grid;\n  gap: 7px;\n}\n\n.admin-canvas-projects-filters label > span,\n.admin-canvas-projects-dialog label > span {\n  color: #70776e;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.admin-canvas-projects-filters input,\n.admin-canvas-projects-filters select,\n.admin-canvas-projects-filters button,\n.admin-canvas-projects-dialog textarea,\n.admin-canvas-projects-dialog button {\n  min-height: 42px;\n  border: 1px solid #d9ded6;\n  border-radius: 10px;\n  background: #fff;\n  color: #242a24;\n  font: inherit;\n}\n\n.admin-canvas-projects-filters input,\n.admin-canvas-projects-filters select,\n.admin-canvas-projects-dialog textarea {\n  padding: 10px 12px;\n  outline: none;\n}\n\n.admin-canvas-projects-filters input:focus,\n.admin-canvas-projects-filters select:focus,\n.admin-canvas-projects-dialog textarea:focus,\n.admin-canvas-projects-priority input:focus {\n  border-color: #96b861;\n  box-shadow: 0 0 0 3px rgba(150, 184, 97, 0.17);\n}\n\n.admin-canvas-projects-filters > button {\n  padding: 0 22px;\n  border-color: #1d251b;\n  background: #1d251b;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.admin-canvas-projects-panel {\n  overflow: hidden;\n  border: 1px solid #e0e5dc;\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 16px 44px rgba(31, 45, 23, 0.05);\n}\n\n.admin-canvas-projects-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #edf0eb;\n}\n\n.admin-canvas-projects-summary span {\n  color: #858b84;\n  font-size: 12px;\n}\n\n.admin-canvas-projects-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  min-height: 180px;\n  padding: 24px;\n  color: #727970;\n  text-align: center;\n}\n\n.admin-canvas-projects-message.is-error { color: #a43737; }\n\n.admin-canvas-projects-message button,\n.admin-canvas-projects-pagination button,\n.admin-canvas-projects-priority button,\n.admin-canvas-projects-actions button {\n  border: 1px solid #d9ded6;\n  border-radius: 8px;\n  background: #fff;\n  color: #424a41;\n  cursor: pointer;\n}\n\n.admin-canvas-projects-table-wrap { overflow-x: auto; }\n\n.admin-canvas-projects-table {\n  width: 100%;\n  min-width: 1120px;\n  border-collapse: collapse;\n}\n\n.admin-canvas-projects-table th,\n.admin-canvas-projects-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #edf0eb;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.admin-canvas-projects-table th {\n  background: #f7f9f5;\n  color: #767d75;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n}\n\n.admin-canvas-projects-table td { font-size: 13px; }\n\n.admin-canvas-projects-table td > strong,\n.admin-canvas-projects-table td > small {\n  display: block;\n}\n\n.admin-canvas-projects-table small {\n  max-width: 220px;\n  margin-top: 4px;\n  overflow: hidden;\n  color: #858c84;\n  font-size: 11px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-canvas-projects-project {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 270px;\n}\n\n.admin-canvas-projects-project > div:last-child {\n  min-width: 0;\n}\n\n.admin-canvas-projects-project strong {\n  display: block;\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-canvas-projects-thumbnail {\n  display: grid;\n  flex: 0 0 68px;\n  width: 68px;\n  height: 48px;\n  place-items: center;\n  overflow: hidden;\n  border-radius: 9px;\n  background: #e9ede6;\n  color: #939b91;\n  font-size: 10px;\n}\n\n.admin-canvas-projects-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.admin-canvas-projects-status {\n  display: inline-flex;\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: #ecefec;\n  color: #646c63;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.admin-canvas-projects-status.is-public {\n  background: #e7f5d7;\n  color: #3d6a22;\n}\n\n.admin-canvas-projects-status.is-disabled {\n  background: #fde6e3;\n  color: #a33b35;\n}\n\n.admin-canvas-projects-priority {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 220px;\n}\n\n.admin-canvas-projects-priority input {\n  width: 86px;\n  min-height: 34px;\n  padding: 6px 8px;\n  border: 1px solid #d9ded6;\n  border-radius: 8px;\n  outline: none;\n}\n\n.admin-canvas-projects-priority button,\n.admin-canvas-projects-actions button {\n  min-height: 34px;\n  padding: 6px 9px;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.admin-canvas-projects-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 150px;\n}\n\n.admin-canvas-projects-actions .is-danger,\n.admin-canvas-projects-dialog .is-danger {\n  border-color: #e4a6a1;\n  background: #fff3f1;\n  color: #a3332d;\n}\n\n.admin-canvas-projects-priority button:disabled,\n.admin-canvas-projects-actions button:disabled,\n.admin-canvas-projects-pagination button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.admin-canvas-projects-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 18px;\n}\n\n.admin-canvas-projects-pagination button { padding: 7px 14px; }\n\n.admin-canvas-projects-pagination span {\n  color: #6c746b;\n  font-size: 12px;\n}\n\n.admin-canvas-projects-dialog-backdrop {\n  position: fixed;\n  z-index: 5000;\n  inset: 0;\n  display: grid;\n  padding: 20px;\n  place-items: center;\n  background: rgba(18, 23, 17, 0.48);\n}\n\n.admin-canvas-projects-dialog {\n  width: min(480px, 100%);\n  padding: 26px;\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 28px 80px rgba(14, 20, 12, 0.25);\n}\n\n.admin-canvas-projects-dialog h2 { margin: 0 0 10px; }\n\n.admin-canvas-projects-dialog p {\n  margin: 0 0 20px;\n  color: #656d64;\n  line-height: 1.6;\n}\n\n.admin-canvas-projects-dialog textarea {\n  width: 100%;\n  resize: vertical;\n}\n\n.admin-canvas-projects-dialog > div {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 22px;\n}\n\n.admin-canvas-projects-dialog button {\n  padding: 0 18px;\n  cursor: pointer;\n}\n\n.canvas-admin-route-state {\n  display: grid;\n  min-height: calc(100vh - 72px);\n  padding: 48px 24px;\n  place-content: center;\n  justify-items: center;\n  color: #586057;\n  text-align: center;\n}\n\n.canvas-admin-route-state h1 {\n  margin: 0 0 8px;\n  color: #222822;\n}\n\n@media (max-width: 900px) {\n  .admin-canvas-projects-page {\n    width: min(100% - 28px, 1500px);\n    padding-top: 34px;\n  }\n\n  .admin-canvas-projects-header { align-items: flex-start; }\n\n  .admin-canvas-projects-filters {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 620px) {\n  .admin-canvas-projects-header {\n    display: grid;\n  }\n\n  .admin-canvas-projects-filters { grid-template-columns: 1fr; }\n\n  .admin-canvas-projects-summary {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
